import { render, staticRenderFns } from "./navTips.vue?vue&type=template&id=493e45f2"
import script from "./navTips.vue?vue&type=script&lang=js"
export * from "./navTips.vue?vue&type=script&lang=js"
import style0 from "./navTips.vue?vue&type=style&index=0&id=493e45f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports